import { CSSProperties } from 'react';

// Pílula de status do redesign: fundo tingido + texto escuro da mesma
// família (contraste AA), no lugar de status em texto puro.

type Tone = 'info' | 'success' | 'warning' | 'danger' | 'neutral';

const TONES: Record<Tone, { bg: string; fg: string }> = {
  info: { bg: '#E8F1FB', fg: '#0E52A0' },
  success: { bg: '#EAF5E8', fg: '#2E7D32' },
  warning: { bg: '#FBF0DC', fg: '#9A6A0B' },
  danger: { bg: '#FAE4E4', fg: '#C43D3D' },
  neutral: { bg: '#EDF1F5', fg: '#5A6B7A' },
};

// A ordem importa: "Não executada" e "Parcialmente executada" também
// terminam em "executada", então vêm antes do match de sucesso.
const LABEL_TONES: Array<{ match: RegExp; tone: Tone }> = [
  { match: /n[aã]o executada|cancel|erro|ocorr[eê]ncia/i, tone: 'danger' },
  { match: /pendente|parcial|aguard|reprocess|separa[cç][aã]o/i, tone: 'warning' },
  { match: /executada|conclu[ií]|finaliz|entregue|sincroniz|dispon[ií]vel/i, tone: 'success' },
  { match: /em rota|em andamento|movido/i, tone: 'info' },
];

export const toneForLabel = (label: string): Tone => {
  const found = LABEL_TONES.find(({ match }) => match.test(label));
  return found ? found.tone : 'neutral';
};

interface IProps {
  label: string;
  tone?: Tone;
  style?: CSSProperties;
}

export const StatusPill = ({ label, tone, style }: IProps) => {
  const colors = TONES[tone || toneForLabel(label)];

  return (
    <span
      style={{
        display: 'inline-block',
        background: colors.bg,
        color: colors.fg,
        fontWeight: 600,
        fontSize: 12,
        lineHeight: 1.4,
        padding: '4px 10px',
        borderRadius: 99,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {label}
    </span>
  );
};

// Chip de rota tingido: mantém a cor da linha do mapa, mas com fundo a 12%
// e texto na própria cor — menos peso visual que o chip sólido.
export const tintedChipStyle = (color?: string): CSSProperties => {
  if (color && /^#[0-9a-fA-F]{6}$/.test(color)) {
    return {
      backgroundColor: `${color}1F`,
      color,
      fontWeight: 600,
    };
  }
  return { color: '#fff', backgroundColor: color };
};
